import SEOMeta from '@/components/base/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const faqItems = [
  {
    question: '香香漫画网的漫画都是免费的吗？',
    answer: '是的，香香漫画网所有漫画资源均免费提供在线阅读，无需付费或会员订阅，用户可以随时随地畅享韩漫、日漫、国漫的精彩内容。',
  },
  {
    question: '香香漫画支持哪些类型的漫画？',
    answer: '香香漫画网涵盖韩漫、日漫、国漫三大品类，包括恋爱、热血、奇幻、悬疑、玄幻、电竞、修仙等多种题材，满足不同读者的阅读偏好。',
  },
  {
    question: '什么是下拉式追更体验？',
    answer: '下拉式追更是一种流畅的阅读方式，用户只需向下滑动页面即可连续阅读漫画章节，无需频繁点击翻页或切换页面，阅读体验更加沉浸和顺畅。',
  },
  {
    question: '香香漫画网的更新频率如何？',
    answer: '香香漫画网保持高频更新，热门漫画通常每日或每周更新最新章节。我们的编辑团队密切关注各大漫画平台的更新动态，确保读者能够第一时间追更。',
  },
  {
    question: '如何在香香漫画网找到我想看的漫画？',
    answer: '您可以通过首页的分类导航进入韩漫、日漫或国漫专区浏览，也可以使用网站搜索功能输入漫画名称或作者名进行查找。热门排行和精选推荐也能帮助您发现好看的漫画。',
  },
];

export default function About() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于香香漫画',
    description: '香香漫画品牌介绍、口碑评价与联系方式',
    url: 'https://www.xiangxiangcomic.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '香香漫画',
      url: 'https://www.xiangxiangcomic.com/',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEOMeta
        title="关于我们 - 香香漫画网：品牌介绍、口碑与联系方式"
        description="了解香香漫画网——韩漫日漫国漫免费在线阅读平台。品牌故事、用户口碑、联系方式一应俱全。我们致力于为漫画爱好者提供优质的免费漫画阅读体验。"
        keywords="香香漫画,关于香香漫画,香香漫画网介绍,漫画阅读平台,免费漫画,联系我们"
        canonicalUrl="https://www.xiangxiangcomic.com/about"
        schema={{ ...schema, ...faqSchema }}
      />

      <Navbar />

      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mb-16">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-heading text-foreground-950 mb-4">
                关于香香漫画
              </h1>
              <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
                香香漫画网，一个专注于韩漫、日漫、国漫免费在线阅读的优质平台
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 mb-16">
              <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4">
                  <i className="ri-lightbulb-line text-xl"></i>
                </div>
                <h2 className="text-xl font-heading text-foreground-950 mb-4">品牌故事</h2>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  香香漫画网成立于对漫画文化的热爱与追求。我们深知漫画爱好者在寻找优质阅读资源时面临的各种困扰——链接失效、广告干扰、更新不及时等问题。
                </p>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  因此，我们打造了香香漫画这个纯净、安全、便捷的漫画阅读平台。从韩漫的细腻情感，到日漫的热血冒险，再到国漫的崛起之作，香香漫画致力于为用户提供一站式的漫画阅读体验。
                </p>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  我们始终坚持"免费、安全、优质"的服务理念，所有漫画资源均可免费在线阅读，无广告干扰，让每一位读者都能沉浸在漫画的世界中。
                </p>
              </div>

              <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 mb-4">
                  <i className="ri-hearts-line text-xl"></i>
                </div>
                <h2 className="text-xl font-heading text-foreground-950 mb-4">用户口碑</h2>
                <div className="space-y-4">
                  {[
                    { name: '小明', text: '香香漫画真的太方便了！下拉式追更体验超级流畅，韩漫日漫国漫都有，已经推荐给身边所有喜欢看漫画的朋友了！', rating: 5 },
                    { name: '漫画控小樱', text: '之前找漫画资源总是很头疼，香香漫画网的出现简直是福音。分类清晰，更新快，而且完全免费，五星好评！', rating: 5 },
                    { name: '追更达人', text: '用了香香漫画之后就看不上别的平台了。安全直达，没有乱七八糟的广告，阅读体验非常棒。推荐！', rating: 5 },
                    { name: '二次元少女', text: '作为一个日漫和韩漫的双料粉丝，香香漫画完美满足了我的需求。资源丰富，更新及时，强烈推荐给大家！', rating: 5 },
                  ].map((review, idx) => (
                    <div key={idx} className="border-b border-background-200/70 pb-4 last:border-0 last:pb-0">
                      <div className="flex items-center gap-2 mb-1.5">
                        <div className="w-7 h-7 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center text-xs font-bold">
                          {review.name[0]}
                        </div>
                        <span className="text-sm font-medium text-foreground-800">{review.name}</span>
                        <div className="flex items-center gap-0.5 ml-auto">
                          {Array.from({ length: review.rating }).map((_, i) => (
                            <div key={i} className="w-3 h-3 flex items-center justify-center">
                              <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                            </div>
                          ))}
                        </div>
                      </div>
                      <p className="text-sm text-foreground-500 leading-relaxed pl-9">{review.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-background-100 rounded-2xl p-6 md:p-8 mb-16">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-500 mb-4">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h2 className="text-xl font-heading text-foreground-950 mb-4">联系我们</h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。香香漫画团队期待与您的沟通！
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">电子邮箱</p>
                    <p className="text-sm font-medium text-foreground-800">contact@xiangxiangcomic.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 flex-shrink-0">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">官方微信</p>
                    <p className="text-sm font-medium text-foreground-800">xiangxiangcomic</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-500 flex-shrink-0">
                    <i className="ri-weibo-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">官方微博</p>
                    <p className="text-sm font-medium text-foreground-800">@香香漫画官方</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl font-heading text-foreground-950 mb-6 text-center">常见问题</h2>
              <div className="max-w-3xl mx-auto space-y-3">
                {faqItems.map((item, idx) => (
                  <details key={idx} className="group bg-background-100 rounded-xl overflow-hidden">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200/50 transition-colors duration-200">
                      <span className="text-sm font-medium text-foreground-800 pr-4">{item.question}</span>
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                        <i className="ri-arrow-down-s-line"></i>
                      </div>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}